module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": _vm.btnSize,
      "icon": "edit"
    },
    on: {
      "click": _vm.chgHandle
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "400",
      "footer-hide": ""
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "font-size": "15px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-information-circle"
    }
  }), _vm._v(" "), _c('span', [_vm._v("修改会员有效期")])], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true,
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "有效期:"
    }
  }, [_c('DatePicker', {
    attrs: {
      "options": _vm.endOptions,
      "type": "date",
      "placeholder": _vm.expireShow,
      "format": "yyyy-MM-dd",
      "placement": "bottom-end"
    },
    model: {
      value: (_vm.expireDate),
      callback: function($$v) {
        _vm.expireDate = $$v
      },
      expression: "expireDate"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "操作类型:"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择操作类型"
    },
    model: {
      value: (_vm.selectValue),
      callback: function($$v) {
        _vm.selectValue = $$v
      },
      expression: "selectValue"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('Divider'), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "110px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.modalConfirm
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.modalCancel
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4855eb88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/book/components/addbookmsgs.vue
// module id = 686
// module chunks = 1